import React from 'react';
import classnames from 'classnames';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

import InputLabel, { InputLabelProps } from '../InputLabel/InputLabel';
import ValidationMessage from '../ValidationMessage';
import { getInputClassForValidationState } from '../ValidationMessage/helper';
import {
  ValidationState,
  ValidationMessageProps
} from '../ValidationMessage/ValidationMessage';
import './DataListSelect.scss';

export interface DataListSelectProps extends React.HTMLAttributes<HTMLElement> {
  async?: boolean;
  inputLabelProps?: InputLabelProps;
  isRequired?: boolean;
  label?: string;
  name: string;
  validationMessage?: string;
  validationProps?: ValidationMessageProps;
  validationState?: ValidationState;
  [key: string]: any;
}

const DataListSelect: React.FunctionComponent<DataListSelectProps> = ({
  async = false,
  className,
  id,
  inputLabelProps,
  isRequired = false,
  label,
  name,
  validationMessage,
  validationProps,
  validationState,
  ...selectProps
}) => {
  const DataSelect: React.ElementType = async ? AsyncSelect : Select;

  return (
    <div className={classnames('input', className)}>
      {label && (
        <InputLabel
          isRequired={isRequired}
          htmlFor={id || name}
          {...inputLabelProps}
        >
          {label}
        </InputLabel>
      )}

      <div
        className={classnames(
          'input__row flex-column',
          getInputClassForValidationState(validationState)
        )}
      >
        <DataSelect
          {...selectProps}
          name={name}
          id={id || name}
          className='DataListSelect'
          classNamePrefix='input__select'
        />

        <ValidationMessage
          validationState={validationState}
          {...validationProps}
        >
          {validationMessage}
        </ValidationMessage>
      </div>
    </div>
  );
};

export default DataListSelect;
